import { NavBar } from "../../components/navBar";
import Footer from "../../components/Footer";
import { useTranslation } from "react-i18next";

export const Error = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow pt-[70px] px-6 py-24">
        <div className="mb-6 rounded-lg border border-yellow-400/40 bg-yellow-500/10 p-4 text-yellow-100">
          {t(
            "pages.profile.error",
            "Non siamo riusciti a recuperare i tuoi dati aggiornati. Stiamo mostrando le ultime informazioni disponibili."
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};
